module.exports = __webpack_public_path__ + "img/a497c56.svg";